import $ from 'jquery'

export default {
    init: (container) => {
        let extContainer = container.find('.ext-container'),
            trigger = container.find('.ext-links'),
            target = container.find('.link-items');

        trigger.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            extContainer.removeClass('Hide');
            let index = $(this).index();
            target.eq(index).removeClass('Hide').siblings().addClass('Hide');
        })

        target.on('mouseleave', function () {
            extContainer.addClass('Hide');
        })
        $(document).on('click', function () {
            extContainer.addClass('Hide');
        })
    }

}


// WEBPACK FOOTER //
// ./modules/footer-channel/js/footer.js